import script from "./MenuBar2.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBar2.vue?vue&type=script&setup=true&lang=js"

import "./MenuBar2.vue?vue&type=style&index=0&id=110e4e86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-110e4e86"]])

export default __exports__